import axiosInstance from "api"
import { Endpoint } from "api/enpoints.types"
import { AxiosError, AxiosResponse } from "axios"
import { useMutation } from "react-query"

import {
  IPostClassesStorePurchaseArgs,
  IPostClassesStorePurchaseInput,
  ITeacherStorePurchaseResult,
} from "./classesStorePurchase.types"

export const useMutationPostClassesStorePurchase = (
  args?: IPostClassesStorePurchaseArgs
) =>
  useMutation<
    AxiosResponse<ITeacherStorePurchaseResult>,
    AxiosError,
    IPostClassesStorePurchaseInput
  >(
    async ({ classId, data }) =>
      await axiosInstance.post(
        Endpoint.CLASSES_STORE_PURCHASE.replace("ID", `${classId}`),
        data
      ),
    args?.options
  )
